const keys = {
  carCreditor: {
    creditorName: {
      placeholder: 'ex: National Bank',
      financed: {
        label: 'Financing company name',
        labelOther: 'Please input the financing company name',
      },
      leased: {
        label: 'Financing company name',
        labelOther: 'Please input the financing company name',
      },
    },
    creditorAddress: {
      placeholder: 'ex. 500 René-Lévesque West, Montreal',
      label: 'Branch address',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
